import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  openNewbuildingBrokerCallbackWidget,
  setGalleryBannerAnalyticsSent,
} from 'shared/actions/newbuildingBrokerOfferBooking';
import { NewbuildingBrokerGalleryBanner } from 'shared/components/NewbuildingBrokerGalleryBanner';
import { useBookingButtonClickHandler } from 'shared/hooks/useBookingButtonClickHandler';
import { getOfferCustomUrl } from 'shared/selectors/analytics';
import { selectFullscreenGalleryOpened } from 'shared/selectors/gallery';
import {
  selectGalleryBannerAnalyticsSent,
  selectOfferBookingLoading,
} from 'shared/selectors/newbuildingBrokerOfferBooking';
import { trackCallbackWidgetOpen } from 'shared/utils/newbuildingBroker/offerBooking';

import { trackBookingButtonShow } from './tracking';

export const NewbuildingBrokerGalleryBookingBannerContainer = () => {
  const isFullscreen = useSelector(selectFullscreenGalleryOpened);
  const offerBookingLoading = useSelector(selectOfferBookingLoading);
  const gaLabel = useSelector(getOfferCustomUrl);
  const galleryBannerAnalyticsSent = useSelector(selectGalleryBannerAnalyticsSent);

  const dispatch = useDispatch();

  const handleBookingShow = React.useCallback(() => {
    if (!galleryBannerAnalyticsSent) {
      trackBookingButtonShow();
      dispatch(setGalleryBannerAnalyticsSent());
    }
  }, [dispatch, galleryBannerAnalyticsSent]);

  const bookingButtonClickHandler = useBookingButtonClickHandler('offer_card_gallery_banner', gaLabel);

  const handleDetailsClick = React.useCallback(() => {
    dispatch(openNewbuildingBrokerCallbackWidget('gallery_label'));
    trackCallbackWidgetOpen(gaLabel, 'gallery');
  }, [dispatch, gaLabel]);

  return (
    <NewbuildingBrokerGalleryBanner
      isFullscreen={isFullscreen}
      title="Эту квартиру можно забронировать"
      buttons={
        <>
          <ActionAfterViewObserver callback={handleBookingShow} wrapper={false}>
            <Button theme="fill_primary" loading={offerBookingLoading} onClick={bookingButtonClickHandler}>
              Заполнить заявку
            </Button>
          </ActionAfterViewObserver>
          <Button theme="stroke_primary" onClick={handleDetailsClick}>
            Узнать подробности
          </Button>
        </>
      }
    />
  );
};
